import { render, staticRenderFns } from "./AdministracaoDetalhe.vue?vue&type=template&id=97417d62"
import script from "./AdministracaoDetalhe.vue?vue&type=script&lang=js"
export * from "./AdministracaoDetalhe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports